import { CatalogCategoryBlock } from './CatalogCategoryBlock';
import { ListLinkCatalog } from './const';

import styles from './CatalogCategoryBlocks.module.scss';

export const CatalogCategoryBlocks = (): JSX.Element => {
  return (
    <div className={styles.Wrapper}>
      <div className={styles.Container}>
        {ListLinkCatalog.map(item => (
          <CatalogCategoryBlock key={item.title} {...item} />
        ))}
      </div>
    </div>
  );
};
